import React from "react";
import { Resource } from "../../types/resources";
import ResourceCard from "./ResourceCard";
import { TimelineRenderRow } from "./timelineRows";
import { TIMELINE_RESOURCE_COLUMN_WIDTH } from "./timelineConstants";

interface ResourceListProps {
  rows: TimelineRenderRow[];
  totalHeight: number;
  onResourceClick?: (resource: Resource) => void;
}

const ResourceList: React.FC<ResourceListProps> = ({
  rows,
  totalHeight,
  onResourceClick,
}) => {
  return (
    <div
      className="resource-list"
      style={{
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden",
        position: "relative",
        willChange: "transform",
      }}
    >
      <div
        style={{
          height: `${Math.max(totalHeight, 1)}px`,
          position: "relative",
        }}
      >
        {rows.map((row) => {
          if (row.type === "group") {
            return (
              <div
                key={row.id}
                style={{
                  position: "absolute",
                  top: `${row.top}px`,
                  left: 0,
                  right: 0,
                  height: `${row.height}px`,
                  padding: "0 12px",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "12px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                  color: "#475569",
                  backgroundColor: "#f8fafc",
                  borderBottom: "1px solid #e2e8f0",
                }}
              >
                {row.label}
              </div>
            );
          }

          return (
            <div
              key={row.id}
              style={{
                position: "absolute",
                top: `${row.top}px`,
                left: 0,
                right: 0,
                height: `${row.height}px`,
              }}
            >
              <ResourceCard
                key={row.resource.id}
                resource={row.resource}
                className="resource-item"
                style={{
                  height: `${row.height}px`,
                  width: `${TIMELINE_RESOURCE_COLUMN_WIDTH}px`,
                  backgroundColor: "white",
                }}
                onClick={onResourceClick}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ResourceList;
